import { getMessages } from '../../../../../../../store/constants';

export const CARD_SECTION_SUBCARDS = getMessages().getText('card_form_section_subcards');
export const CARD_SUBCARD_ADD = getMessages().getText('card_form_subcard_add');
export const CARD_SUBCARDS_PIN = getMessages().getText('common.pin_to_card');
export const CARD_SUBCARDS_UNPIN = getMessages().getText('common.unpin_from_card');
export const CARD_SUBCARDS_DONE = 'card_form_subcards_done';
export const CARD_SUBCARDS_HIDE_DONE = getMessages().getText('card_form_subcards_hide_done');
export const CARD_SUBCARDS_SHOW_DONE = getMessages().getText('card_form_subcards_show_done');
